import React          from 'react'
import { withRouter } from 'react-router'
import PropTypes      from 'prop-types'
import classNames     from 'classnames'
import { Skeleton }   from 'antd'
import { Link }       from 'react-router-dom'

import { AccountOptions, Icons, Navigation, NavigationItem, LanguageSwitch } from 'components'
import { generate, users, t }                                                from 'tools'
import config                                                                from 'config'

import './admin-panel.scss'

class AdminPanel extends React.Component {

    static propTypes = {
        noLoad: PropTypes.bool,

        account:     PropTypes.object,
        user:        PropTypes.object,
        companies:   PropTypes.array,
        currentPath: PropTypes.string,

        catchBack: PropTypes.func,
        onExpand:  PropTypes.func,
        onAccount: PropTypes.func,
        onSignOut: PropTypes.func
    }

    constructor ( props ) {
        super( props )

        this.state = {
            adminExpanded: false,
            userExpanded:  window.innerWidth < config.ui.breakpoints.mobile,
            showAccounts:  false
        }

        ;( props.catchBack ) && ( props.catchBack( this ))

        this.set = generate.set( this )
    }

    componentDidUpdate ( prevProps, prevState ) {
        const
            { adminExpanded } = this.state

        ;( adminExpanded !== prevState.adminExpanded && this.props.onExpand ) && ( this.props.onExpand())
    }

    logout = () => this.props.onSignOut()
    goSettings = () => {
        const
            { history, user, account } = this.props

            ;( account.id === user.id )
            ? history.push( '/account' )
            : history.push( '/company' )
    }

    toggle = which => () => this.set[ `${which}Expanded` ]( !this.state[ `${which}Expanded` ])
    expand = which => () => this.set[ `${which}Expanded` ]( true )

    collapse = which => () => {
        const
            { showAccounts } = this.state

        if ( which !== 'admin' || !showAccounts ) {
            this.set[ `${which}Expanded` ]( false )
        }
    }

    switchAccount = () => this.set.showAccounts( !this.state.showAccounts )

    setAccount = id => () => {
        this.props.onAccount( id )

        this.set.state({
            adminExpanded: false,
            showAccounts:  false,
            userExpanded:  window.innerWidth < config.ui.breakpoints.mobile,
        })
    }

    accounts = () => {
        const
            { user, companies } = this.props,
            res = [ {
                id:          user.id,
                name:        `${user.first_name} ${user.last_name}`.trim(),
                image:       user.avatar,
                permissions: { team: false }
            } ]

        if ( companies ) {
            companies.forEach( c => res.push( users.prepare( c )))
        }

        return res
    }

    publicPanel = () => {
        const
            { adminExpanded } = this.state

        return (
            <div className="panel-navigation">
                <div className="public-logo">
                    {
                        adminExpanded
                            ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="135" height="24" fill="none">
                                        <path fill="#fff" fillRule="evenodd" d="M16.5272 6.09493h6.4874c.3926 0 .8543-.28094 1.0321-.62749L26.4801.726717c.1778-.346349.0042-.6274927-.3879-.6274927H.709989C.317309.0992243 0 .413728 0 .801688V5.39246c0 .38856.317892.70247.710032.70247H9.1857V23.2981c0 .3867.31815.7019.7106.7019h5.9203c.3928 0 .7106-.3143.7106-.7019V6.09493zM88.1115.814697c0-.35629.2888-.645121.6451-.645121h18.3584c.356 0 .645.28883.645.64512V5.15262c0 .35629-.289.64512-.645.64512H94.9359v3.38859h9.1921c.482 0 .794.50943.575.93867l-2.217 4.3379c-.11.2158-.332.3516-.574.3516h-6.9761v3.4198h12.1791c.356 0 .645.2888.645.6451v4.3379c0 .3563-.289.6451-.645.6451H88.7566c-.3563 0-.6451-.2888-.6451-.6451V.814697zM115.176.169576c-.356 0-.645.288831-.645.645121V2.98366h-.004V21.0483h.004v2.169c0 .3563.289.6451.645.6451h18.358c.357 0 .645-.2888.645-.6451v-4.3379c0-.3563-.288-.6451-.645-.6451h-12.255v-3.4198h7.052c.242 0 .464-.1358.574-.3516l2.217-4.3379c.219-.42924-.092-.93867-.574-.93867h-9.269V5.79774h12.255c.357 0 .645-.28883.645-.64512V.814696c0-.35629-.288-.64512-.645-.64512h-18.358zM42.0673 15.454h-5.9194l2.9597-5.86062 2.9597 5.86062zm-8.9474 5.9957h11.9754l.9007 1.7836c.1764.3493.6354.6299 1.0267.6299h5.9727c.3911 0 .5665-.2814.3912-.6286L42.0379.763005c-.1755-.347652-.635-.628575-1.0267-.628575H37.2028c-.3911 0-.85.280923-1.0256.628575L24.8286 23.2346c-.1753.3472.0001.6286.3911.6286h5.9727c.3914 0 .8503-.2805 1.0258-.6281l.9017-1.7854zm32.218-16.26168h6.5542c1.1487 0 2.0799.91025 2.0799 2.03311 0 1.12285-.9312 2.0331-2.0799 2.0331v.0064h-6.5542V5.18802zm7.0759 9.17258h-7.0759v4.1308h7.0192c.074.0065.1489.0098.2247.0098 1.2699 0 2.2994-.9281 2.2994-2.073 0-1.1449-1.0295-2.073-2.2994-2.073-.0565 0-.1126.0018-.168.0054zm8.8966 2.886c0-2.5164-1.3334-4.7062-3.2998-5.8352 1.5164-1.1423 2.5018-2.99121 2.5018-5.0777 0-3.37214-2.5738-6.123643-5.8038-6.274832L65.8484.0171764 59.1602.0002463c-.3569-.0009036-.6467.2881897-.6467.6451177V23.2601c0 .3563.2888.6451.6451.6451h6.6898l9.5513-.0035c3.3014-.2539 5.9107-3.135 5.9107-6.6551z" clipRule="evenodd"/>
                                    </svg>
                                )
                            : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" fill="none">
                                        <path fill="#fff" fillRule="evenodd" d="M23.0146 5.9957c.3926 0 .8543-.28093 1.0321-.62749L26.4801.627493C26.6579.281143 26.4843 0 26.0922 0H.709989C.317309 0 0 .314504 0 .702464V5.29324c0 .38855.317892.70246.710032.70246H9.1857v17.2031c0 .3868.31815.7019.7106.7019h5.9203c.3928 0 .7106-.3142.7106-.7019V5.9957h6.4874z" clipRule="evenodd"/>
                                    </svg>
                                )
                    }
                </div>
                <div className="section">
                    <nav className="admin-navigation">
                        <ul className="admin-navigation-items">
                            <li>
                                <Link to="/login">
                                    <NavigationItem
                                        active = { false }
                                        name = { t( 'admin.signUpOrSignIn' ) }
                                        icon = { <Icons.SignIn /> }
                                    />
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        )
    }

    content = () => {
        const
            { account, currentPath, noLoad } = this.props,
            { showAccounts, userExpanded } = this.state

        if ( !account ) {
            if ( noLoad ) {
                return this.publicPanel()
            }

            return (
                <Skeleton.Avatar
                    active
                    shape = "square"
                    style={{ width: 48, height: 48, margin: '16px 8px' }}
                />
            )
        }

        if ( showAccounts ) {
            return (
                <AccountOptions
                    accounts = { this.accounts() }

                    onReturn = { this.switchAccount }
                    onSelect = { this.setAccount }
                    onSignOut = { this.logout }
                />
            )
        }

        return (
            <Navigation
                account = { account }
                currentPath = { currentPath }
                expanded = { userExpanded }
                canSwitch = { this.accounts().length > 1 }

                onAccountSettings = { this.goSettings }
                onSwitchAccount = { this.switchAccount }
                onSignOut = { this.logout }
                onTogglePanel = {
                    window.innerWidth < config.ui.breakpoints.mobile
                        ? this.toggle( 'admin' )
                        : this.toggle( 'user' )
                }
            />
        )
    }

    overlay = () => {
        if ( window.innerWidth >= config.ui.breakpoints.mobile ) { return { zIndex: 1001 } }

        const
            { showAccounts } = this.state

        return showAccounts
            ? { zIndex: 1003 }
            : { zIndex: 1001 }
    }

    render () {
        const
            { adminExpanded } = this.state,
            cls = classNames(
                'content',
                adminExpanded && 'expanded',
            )

        return (
            <div
                className = "admin-panel"
                style = { this.overlay() }

                onMouseEnter = { this.expand( 'admin' ) }
                onMouseLeave = { this.collapse( 'admin' ) }
            >
                <div className={cls}>
                    { this.content() }
                    <footer className="admin-panel-foot">
                        <LanguageSwitch
                            className = "panel-switch"
                            hide = { !adminExpanded }
                        />
                    </footer>
                </div>
            </div>
        )
    }
}

export default withRouter( AdminPanel )
